//Libs
import React, { Component, Fragment } from 'react';
import randomColor from 'randomcolor';
//Componentes Material
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
//Ícones
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
//Gráficos
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip } from 'recharts';
//Components
import CenteredCircularProgress from '../CenteredCircularProgress';
import CustomizedAxisTick from './CustomizedAxisTick';
//Controllers
import RelatorioController from '../../controllers/RelatorioController';
//Modelos
import AvaliacaoData from '../../models/relatorios/AvaliacaoData';
//Utils
import { formatarDataUTC, formatarDataMes } from '../../utils/formatarData';

/**
 * Componente para exibir um gráfico com as avaliações dos últimos 30 dias
 */
class RelatorioAvaliacoes extends Component {
    constructor(props) {
        super(props);
        //Controllers
        this.relatorioController = new RelatorioController();
        //Estado inicial
        this.state = {
            carregando: true,
            dados: AvaliacaoData.clone({ }),
            erros: [ ]
        };
    }

    async componentDidMount() {
        //Consulta os dados da API
        const result = await this.relatorioController.avaliacoes();
        //Caso a consulta ocorra com sucesso
        if (result.sucesso) {
            this.setState({ carregando: false, dados: result.dados });
        } else {
            this.setState({ carregando: false, erros: result.erros });
        }

    }

    /**
     * Renderiza o gráfico com os dados retornados
     * @return {Object} Retorna o componente do gráfico
     */
    renderizarGrafico30dias() {
        const { dados } = this.state;
        const itensFormatados = dados.ultimos30dias.map(item => ({ data: formatarDataUTC(new Date(item.data)), quantidade: item.quantidade }));
        const cor = randomColor({ seed: 0, luminosity: 'light' });

        return (
            <ResponsiveContainer height={200} >
                <LineChart data={itensFormatados} margin={{top: 5, right: 15, left: 5, bottom: 40}}>
                    <XAxis dataKey="data" interval="preserveStart" tick={<CustomizedAxisTick />} />
                    <YAxis type="number" allowDecimals={false} />
                    <Tooltip/>
                    <Line type="monotone" dataKey="quantidade" stroke={cor} activeDot={{ r: 4 }} dot={{ r: 2 }}/>
                </LineChart>
            </ResponsiveContainer>
        );
    }

    /**
     * Renderiza o gráfico com os dados retornados
     * @return {Object} Retorna o componente do gráfico
     */
    renderizarGrafico6meses() {
        const { dados } = this.state;
        const itensFormatados = dados.ultimos6meses.map(item => ({ data: formatarDataMes(new Date(item.data)), quantidade: item.quantidade }));
        const cor = randomColor({ seed: 0, luminosity: 'light' });

        return (
            <ResponsiveContainer height={200} >
                <LineChart data={itensFormatados} margin={{top: 5, right: 15, left: 5, bottom: 40}}>
                    <XAxis dataKey="data" interval="preserveStart" tick={<CustomizedAxisTick />} />
                    <YAxis type="number" allowDecimals={false} />
                    <Tooltip/>
                    <Line type="monotone" dataKey="quantidade" stroke={cor} activeDot={{ r: 4 }} dot={{ r: 2 }}/>
                </LineChart>
            </ResponsiveContainer>
        );
    }

    render() {
        const { carregando } = this.state;

        return (
            <Fragment>
                <Grid item xs={12} md={6} >
                    <Card>
                        <CardHeader avatar={<PlaylistAddCheckIcon />} title="Avaliações últimos 30 dias" />
                        <CardContent>
                            { carregando && <CenteredCircularProgress />  }
                            { !carregando && this.renderizarGrafico30dias() }
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Card>
                        <CardHeader avatar={<PlaylistAddCheckIcon />} title="Avaliações últimos 6 meses" />
                        <CardContent>
                            { carregando && <CenteredCircularProgress />  }
                            { !carregando && this.renderizarGrafico6meses() }
                        </CardContent>
                    </Card>
                </Grid>
            </Fragment>
        );
    }
}

export default RelatorioAvaliacoes;